import { Controller } from "@hotwired/stimulus"

// Filters a person list while preserving checked state.
// Usage: data-controller="chat-member-select" on the wrapper div.
//   data-chat-member-select-target="search"  → the search <input>
//   data-chat-member-select-target="item"    → each person row (.chat-member-select-item)
//   data-chat-member-select-target="chips"   → container for selected-person chips
//   data-chat-member-select-target="empty"   → "no results" message
export default class extends Controller {
  static targets = ["search", "item", "chips", "empty"]

  connect() {
    this._renderChips()
    // Watch checkboxes for changes even when filtered out
    this.element.querySelectorAll("input[type=checkbox]").forEach(cb => {
      cb.addEventListener("change", () => this._renderChips())
    })
  }

  filter() {
    const q = this.searchTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.itemTargets.forEach(item => {
      const name = item.querySelector(".chat-member-name")?.textContent?.toLowerCase() || ""
      const cb   = item.querySelector("input[type=checkbox]")
      // Always show checked items (keeps selected visible even when filtered)
      const show = !q || name.includes(q) || cb?.checked
      item.style.display = show ? "" : "none"
      if (show) visibleCount++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.style.display = visibleCount === 0 ? "" : "none"
    }
  }

  // Build/refresh the chips row from currently checked boxes
  _renderChips() {
    if (!this.hasChipsTarget) return
    const checked = this.element.querySelectorAll("input[type=checkbox]:checked")
    if (checked.length === 0) {
      this.chipsTarget.innerHTML = ""
      this.chipsTarget.style.display = "none"
      return
    }
    this.chipsTarget.style.display = "flex"
    this.chipsTarget.innerHTML = [...checked].map(cb => {
      const label = this.element.querySelector(`label[for="${cb.id}"]`)
      const name  = label?.querySelector(".chat-member-name")?.textContent?.trim() || cb.value
      return `<span class="chat-member-chip" data-cb-id="${cb.id}">
        ${name}
        <button type="button" class="chat-member-chip-remove" data-cb-id="${cb.id}" aria-label="Eltávolít">×</button>
      </span>`
    }).join("")

    // Chip remove buttons
    this.chipsTarget.querySelectorAll(".chat-member-chip-remove").forEach(btn => {
      btn.addEventListener("click", (e) => {
        const cbId = e.currentTarget.dataset.cbId
        const cb = this.element.querySelector(`#${cbId}`)
        if (cb) { cb.checked = false; cb.dispatchEvent(new Event("change")) }
        this._renderChips()
      })
    })
  }
}
